import DonorTypes from '@/constants/constituents/DonorTypes';

const isUserDonorType = (donor) => donor?.donorType !== DonorTypes.ORG;

export { isUserDonorType };
